import * as React from 'react';
import './PaymentMethodCard.css';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';

export default function PaymentMethodCard({ method, description, imageSrc, onSelect, selected }) {
  const publicURL = 'https://bucketlistguitars.com/wp-content/reactpress/apps/blg-react-sell/build/assets/';
  let imageUrl = method === "PayPal" ? publicURL + 'PayPal_Logo.png'
                    : method === "Venmo" ? "https://images.ctfassets.net/gkyt4bl1j2fs/4pp7c6YvscP62B8UGRR2NA/2b69b744d7d81df1f3e22a599fc13857/dark_background.png?w=640&h=288&q=50&fm=webp&bg=transparent"
                    : publicURL + 'Check_Logo.png';

  const cardStyles = {
    maxWidth: 345,
    minWidth: 175,
    margin: '10px',
    '@media (max-width: 898px)': {
      margin: '5px',
    },
    '@media (max-width: 768px)': {
      margin: '15px',
    }
};

  return (
    <Card sx={cardStyles} raised={selected} elevation={selected ? 20: 0} className="paymentMethodCard">
      <CardActionArea onClick={() => onSelect(method)}>
        <CardMedia
          component="img"
          height="140"
          image={imageUrl}
          style={{objectFit: 'contain', backgroundColor: 'black', padding: '25px', filter: method == "Check" ? 'brightness(2.5)' : undefined, paddingBottom:  method == "Check" ? '45px': '25px', maxHeight: 140, borderRadius: 0 }}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {method}
          </Typography>
          <Typography variant="body2" color="text.secondary" className="wrap-text">
            {description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
